export default __webpack_public_path__ + "static/media/Incipio.b2cb3c7a.svg";